export default "__VITE_ASSET__djdFicyi__"